import { AppointmentRequestAgreementFragment } from '@/generated/graphql';
import { Checkbox } from 'antd';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { extractTranslation } from '../../helpers/formatters';

interface AppointmentRequestAgreementsProps {
  appointmentRequestAgreements: AppointmentRequestAgreementFragment[] | undefined;
  setAppointmentRequestAgreements:
    | ((agreements: AppointmentRequestAgreementFragment[] | undefined) => void)
    | undefined;
}

export const AppointmentRequestAgreements: FC<AppointmentRequestAgreementsProps> = ({
  appointmentRequestAgreements,
  setAppointmentRequestAgreements,
}) => {
  const router = useRouter();

  const locale = router.locale;

  const onChange = (index: number, value: boolean) => {
    const updatedAgreements = appointmentRequestAgreements?.map((agreement, i) =>
      i === index ? { ...agreement, accepted: value } : agreement,
    );

    setAppointmentRequestAgreements?.(updatedAgreements);
  };

  return (
    <div>
      {appointmentRequestAgreements?.map((agreement, index) => (
        <div key={index}>
          <Checkbox
            checked={agreement?.accepted ?? undefined}
            onChange={(e) => onChange(index, e.target.checked)}
            key={index}
          >
            {agreement?.template?.mandatory && <span style={{ color: '#ae0000' }}>{'* '}</span>}
            {extractTranslation(agreement?.template?.description, locale)}
          </Checkbox>
        </div>
      ))}
    </div>
  );
};
